import React from 'react';

export const name = 'lock';

export const Lock = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99951 5.52937V15.3619H14.0008V5.52937H11.9983V2.63812H6.00201V5.52937H3.99951Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <line
      x1="6"
      y1="5.53497"
      x2="12"
      y2="5.53497"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M8.99444 12.0712C10.0227 12.0712 10.8563 11.2376 10.8563 10.2093C10.8563 9.18106 10.0227 8.34747 8.99444 8.34747C7.96616 8.34747 7.13257 9.18106 7.13257 10.2093C7.13257 11.2376 7.96616 12.0712 8.99444 12.0712Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
    />
    <path
      d="M8.99438 13.9218V12.285"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
  </svg>
);
